import { NuggetDetailResponse, UpdateNuggetRequest } from '@spe-content-store/interfaces';
import { Nugget, NuggetStatus, NuggetType } from '@shared/models/sequence.model';

/** Non-privileged viewers only receive formal, trainee-visible nuggets, so the extended fields default to that. */
export const toNugget = (detail: NuggetDetailResponse, liked: boolean): Nugget => ({
    id: detail.id,
    type: detail.type as NuggetType,
    name: detail.name,
    status: (detail.status ?? 'formal') as NuggetStatus,
    apprentVis: detail.visibleToTrainees ?? true,
    country: detail.countries ?? [],
    link: detail.link,
    documentName: detail.documentName,
    author: detail.author,
    createdBy: detail.uploader,
    description: detail.description,
    formalDate: detail.formalDate,
    creationDate: detail.creationDate,
    liked,
    likeCount: detail.likeCount,
    commentCount: detail.commentCount
});

/** Builds the full-replacement body for the nugget as it currently is, so unrelated fields are preserved. */
export const toUpdateNuggetRequest = (
    nugget: Nugget,
    changes: Partial<UpdateNuggetRequest> = {}
): UpdateNuggetRequest => ({
    name: nugget.name,
    type: nugget.type,
    apprentVis: nugget.apprentVis,
    description: nugget.description || undefined,
    author: nugget.author || undefined,
    link: nugget.type === 'document' ? undefined : nugget.link,
    documentName: nugget.type === 'link' ? undefined : nugget.documentName,
    countries: nugget.country.length > 0 ? nugget.country : undefined,
    ...changes
});
